"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemStandardClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../constants/sdk.constants");
const serializers_1 = require("../serializers");
class ItemStandardClient {
    static newInstance(options, retryOptions) {
        return new ItemStandardClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new serializers_1.ItemStandardSerializer());
    }
    constructor(client, itemStandardSerializer) {
        this.client = client;
        this.itemStandardSerializer = itemStandardSerializer;
    }
    async findByExternalItemId(externalItemIds, filter, headers) {
        const { standardSetGlobalIds, hierarchyLevels } = filter;
        const response = await this.client.get(`${sdk_constants_1.AUTHORING_API_PREFIX}/itemStandards.findByExternalItemId`, {
            headers,
            params: {
                externalItemId: externalItemIds,
                standardSetGlobalId: standardSetGlobalIds,
                hierarchyLevel: hierarchyLevels,
            },
        });
        return response.body.data.map((itemStandard) => this.itemStandardSerializer.serializeOne(itemStandard));
    }
    async findByAssessmentTemplateId(assessmentTemplateIds, standardSetGlobalIds, hierarchyLevels, headers) {
        const response = await this.client.post(`${sdk_constants_1.AUTHORING_API_PREFIX}/itemStandards.findByAssessmentTemplateId`, {
            assessmentTemplateIds,
            standardSetGlobalIds,
            hierarchyLevels,
        }, {
            headers,
        });
        return response.body.data.map((assessmentTemplateItemStandard) => this.itemStandardSerializer.serializeAssessmentTemplateItemStandard(assessmentTemplateItemStandard));
    }
}
exports.ItemStandardClient = ItemStandardClient;
//# sourceMappingURL=item-standard.client.js.map